import { useState, type ReactElement } from 'react'
import { Page } from '@components'
import { useLocationAudit, useTranslation } from '@front/model'
import { isNotEmpty, type LocationPlaceId } from '@terros/common'
import { LocationAuditSearchBar } from './LocationAuditSearchBar'
import { LocationAuditTable } from './table'
import { createFileRoute } from '@tanstack/react-router'

function LocationAuditRoute(): ReactElement {
  const { t } = useTranslation()
  const [selectedPlaceId, setSelectedPlaceId] = useState<LocationPlaceId>('')

  const handleSelect = (placeId: LocationPlaceId): void => {
    setSelectedPlaceId(placeId)
  }

  return (
    <Page>
      <Page.Heading title={t('Activity Trail')} />
      <Page.FunctionBar>
        <LocationAuditSearchBar onSelect={handleSelect} />
      </Page.FunctionBar>
      {isNotEmpty(selectedPlaceId) ? (
        <AuditTable placeId={selectedPlaceId} />
      ) : (
        <Page.Hero
          title={t('Search for a place or an address to see activity at that location')}
          icon='search_activity'
        />
      )}
    </Page>
  )
}

const AuditTable = ({ placeId }: { placeId: LocationPlaceId }): ReactElement => {
  const { data: auditRecords = [], isLoading: auditLoading } = useLocationAudit(placeId)
  return (
    <Page.Content scrollArea>
      <LocationAuditTable isLoading={auditLoading} records={auditRecords} />
    </Page.Content>
  )
}

export const Route = createFileRoute('/location/audit/')({
  component: LocationAuditRoute,
})
